import React, { useState, useEffect } from 'react';
import api from '../api/api';
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ToastMessage from '../utils/mui/righttoptoast';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { getPracticeId } from '../config/practice';
const AddRoom = ({
  editingRoom,
  newRoomName,
  setNewRoomName,
  newRoomStatus,
  setNewRoomStatus,
  roomExistsError,
  closeModal,
  handleAddRoom,
  handleSaveEdit,
  setAddedRoom,
  fetchSignIndata,
  fetchRoomData,
  darkMode,selectedPatientInroom,
  rooms
}) => {
  const [room, setRoom] = useState([]); // Room data from API
  const [loading, setLoading] = useState(false); // Loading state
  const [filteredRooms, setFilteredRooms] = useState([]); // Filtered room list based on input
  const practiseid = getPracticeId();
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [selectedFromSuggestion, setSelectedFromSuggestion] = useState(false); // Track if selected from suggestions
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
  const [hide,setUnhide]=useState(true);
  const [showHideConfirmationModal, setShowHideConfirmationModal] = useState(false);
    const handleToastClose = () => {
      setOpenToast(false)
  };
  // Fetch data from the API
  const fetchData = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/rooms/get`);
      if (response.status === 200) {
        setRoom(response.data); // Accessing the data array
      } else {
        setRoom([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Filter rooms based on the input value
  useEffect(() => {
    if (newRoomName) {
      const filtered = room.filter(r =>
        r.room.toLowerCase().includes(newRoomName.toLowerCase())
      );
      setFilteredRooms(filtered);
    } else {
      setFilteredRooms([]);
    }
  }, [newRoomName, room]);

  // Fetch room data on component mount
  useEffect(() => {
    fetchData();
  }, []);

  // Handle suggestion click
  const handleSuggestionClick = (suggestion) => {
    setNewRoomName(suggestion.room); // Set selected room name into the input
    setAddedRoom({ type: suggestion.type, room: suggestion.room });
    setFilteredRooms([]); // Clear the suggestion list
    setShowSuggestions(false); // Hide suggestions
    setSelectedFromSuggestion(true); // Mark that the room was selected from suggestions
  };

  const handleInputChange = (e) => {
    setNewRoomName(e.target.value); // Set the input value
    setSelectedFromSuggestion(false); // Reset the suggestion flag
    setShowSuggestions(true); // Show suggestions whenever user types
  };



  const handleAddRoomApi = async () => {
    if (newRoomName.trim() === "") {
      return; // Avoid empty room name submission
    }
    try {
      // setLoading(true);
      const response = await api.post(`/v1/${practiseid}/rooms/create_room?roomno=${newRoomName}&status=${newRoomStatus}`);
      if (response.status === 200) {
        setAddedRoom({ room: newRoomName.toUpperCase(), type: 'East' });
        setToastMessage('Room Create Successfully!')
        setToastSeverity('success');
        setOpenToast(true);
        fetchRoomData()
        setTimeout(() => {
          handleCloseModal()
        }, 1000);
        setTimeout(() => {
          setOpenToast(false);  
        }, 2000);
      } else {
        console.error("Failed to create room");
      }
    } catch (error) {
      console.error("Error creating room:", error);
    } finally {
      setLoading(false); // Set loading to false after the request completes
    }
  };

  const handleSubmit = () => {
    const isRoomInSuggestions = filteredRooms.some(
      (r) => r.room.toLowerCase() === newRoomName.toLowerCase()
    );
    if (editingRoom) {
        handleSaveEdit();
    } else {
      if (
        !selectedFromSuggestion &&
        newRoomName.trim() !== "" &&
        !isRoomInSuggestions
      ) {
        handleAddRoomApi();
  
      } else if (newRoomName.trim() === "") {
        setToastMessage("Room name cannot be empty");
        setToastSeverity("error");
        setOpenToast(true);
      } else {
        handleAddRoom();
      }
    }
    fetchRoomData()
  };
  useEffect(() => {
    if (!editingRoom) {
      setNewRoomStatus("Y");  // Set default status to ACTIVE when adding a new room
    }
  }, [editingRoom]);


  const handleHideRoomClick = () => {
    handleRoomDelete({DeletedRoom:filteredRooms[0].room})
  };

  // Handle hiding the room
  const confirmHideRoom = () => {
    // Here, implement the logic to hide the room (e.g., API call)
    setUnhide(true); // For now, just hide it
    setShowHideConfirmationModal(false); // Close the modal
  };

  const cancelHideRoom = () => {
    setShowHideConfirmationModal(false); // Close the modal without hiding the room
  };

 const handleRoomDelete =  async ({DeletedRoom}) => {
  try {
    const response = await api.delete(`/v1/${practiseid}/rooms/delete-room?room_no=${DeletedRoom}`);
    if (response.status === 200) {
      setToastMessage('Room Deleted Successfully!')
      setToastSeverity('success');
      setOpenToast(true);
      fetchRoomData()
      setTimeout(() => {
        closeModal()
      }, 1000);
      setTimeout(() => {
        setOpenToast(false);  
      }, 2000);
      
    } else {
      setToastMessage("Deleting this room failed");
      setToastSeverity("error");
      setOpenToast(true);
    }
  } catch (error) {
    console.error(error);
  }
 }
console.log('SelectedPateint', editingRoom)

const handleCloseModal=()=>{
  closeModal();
  setNewRoomName("")
  setShowSuggestions('');
}

 return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className={`flex flex-col p-6 rounded-md ${darkMode?'bg-[#333333]':"bg-white"} shadow-md w-1/3`}>
      
<div className='flex w-full justify-between'>
<h2 className="text-xl mb-4 font-inter text-left">
          {editingRoom ? 'Edit Room' : 'Add New Room'}
        </h2>
        <div onClick={handleHideRoomClick} className="mb-1">
  {hide && editingRoom?.patients?.length === 0 && (
    <button className={`px-2 ${darkMode ? 'bg-[#333333]' : 'bg-gray-200'} border-2 border-gray-300 rounded flex items-center`}>
      Delete Room <DeleteForeverIcon style={{ height: '18px' }} />
    </button>
  )}
</div>

      </div>

        <div>
          
          <div className="flex flex-col">
            <label className="text-left">Room Name</label>
            <input
              type="text"
              placeholder="Room Name"
              value={newRoomName}
              onChange={handleInputChange}
              className={`border border-gray-300 p-2 w-full  rounded ${darkMode?'bg-[#374151CC]':"bg-white"}`}
            />
            {showSuggestions && filteredRooms.length > 0 && !editingRoom && (
              <ul className={`${darkMode?'bg-[#374151CC]':"bg-white"} border border-gray-300 rounded max-h-24 overflow-y-auto`}>
                {filteredRooms.map((r) => (
                  <li
                    key={r.id}
                    onClick={() => handleSuggestionClick(r)}
                    className="p-2 cursor-pointer hover:bg-gray-200"
                  >
                    {r.room}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-left">Status</label>
            <select
  value={newRoomStatus}
  onChange={(e) => setNewRoomStatus(e.target.value === 'Y' ? 'Y' : "N")}
  className={`border border-gray-300 p-2 w-full mb-4 ${darkMode?'bg-[#374151CC]':"bg-white"}`}
>
  <option value='Y'>ACTIVE</option>
  <option value="N">INACTIVE</option>
           </select>



          </div>
          {roomExistsError && (
            <div className="text-red-500 text-sm mb-4">
              A room with this name already exists!
            </div>
          )}
          <div className="flex justify-end space-x-2">
            <button onClick={handleCloseModal} className="px-4 py-2 bg-gray-100 text-black rounded">
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-3 py-1 bg-[#50869A] text-white rounded"
            >
              {editingRoom ? 'Save ' : 'Add Room'}
            </button>
          </div>
        </div>
      </div>
      <Backdrop
        sx={{
          color: 'secondary.main',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
        <Dialog
        open={showHideConfirmationModal}
        onClose={cancelHideRoom}
      >
        <DialogTitle>Confirm Hide Room</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to hide this room?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelHideRoom} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmHideRoom} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddRoom;
